"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePlayerForCharacter = resolvePlayerForCharacter;
exports.getPartnerCharacterName = getPartnerCharacterName;
exports.buildVariableContextForCharacter = buildVariableContextForCharacter;
exports.readVariableForCharacter = readVariableForCharacter;
exports.createEvaluateConditionForCharacter = createEvaluateConditionForCharacter;
const VariableStore_1 = require("./VariableStore");
/**
 * Resolves the player record for a character name in the current session.
 * Falls back to {@code currentPlayer} when names match; returns undefined when unknown.
 */
function resolvePlayerForCharacter(gameSession, currentPlayer, characterName) {
    const trimmed = (characterName ?? '').toString().trim();
    if (!trimmed) {
        return undefined;
    }
    return (gameSession.getPlayerByCharacter(trimmed) ??
        gameSession.players.find((p) => p.currentCharacter === trimmed) ??
        (trimmed === currentPlayer.characterName || trimmed === currentPlayer.currentCharacter
            ? currentPlayer
            : undefined));
}
/** Character name of the other human player in the session, or empty when solo. */
function getPartnerCharacterName(gameSession, currentPlayer) {
    const other = gameSession.players.find((p) => p.id !== currentPlayer.id);
    return other?.characterName?.trim() || '';
}
function buildVariableContextForCharacter(gameSession, currentPlayer, characterName) {
    const trimmed = (characterName ?? '').toString().trim();
    if (!trimmed) {
        return undefined;
    }
    const target = resolvePlayerForCharacter(gameSession, currentPlayer, trimmed);
    if (target) {
        return VariableStore_1.VariableStore.buildVariableContext(target.id, target.characterName, target.currentScene, target.userId || 'anonymous');
    }
    // Characters without a player slot (e.g. NPCs) still have character-scoped variables.
    return VariableStore_1.VariableStore.buildVariableContext(currentPlayer.id, trimmed, currentPlayer.currentScene, currentPlayer.userId || 'anonymous');
}
function readVariableForCharacter(variableStore, gameSession, currentPlayer, characterName, variableName) {
    const name = (variableName ?? '').toString().trim();
    if (!name) {
        return undefined;
    }
    const context = buildVariableContextForCharacter(gameSession, currentPlayer, characterName);
    if (!context) {
        return undefined;
    }
    return variableStore.getVariable(name, context);
}
/**
 * Builds {@code evaluateConditionForCharacter(characterName, script)} using the supplied executor.
 * Pass {@link ScriptEvaluator.executeCondition} bound per target player from script hosts.
 */
function createEvaluateConditionForCharacter(gameSession, currentPlayer, executeForPlayer) {
    return (characterName, script) => {
        const trimmed = (script ?? '').trim();
        if (!trimmed) {
            return true;
        }
        const target = resolvePlayerForCharacter(gameSession, currentPlayer, characterName);
        if (!target) {
            return false;
        }
        return executeForPlayer(trimmed, target);
    };
}
//# sourceMappingURL=characterScriptContext.js.map